import { FormFieldTypes } from "../../../data/formFieldType";

export const gmapPricingTableFormData = {
  // name: 'CareerHistory',
  initialState: {
    standardHalfYear: null,
    standard1Year: null,
    standard2Year: null,
    standard2YearLimitedTimeOnly: null,
    // Subsidiary
    subsidiaryHalfYear: null,
    subsidiary1Year: null,
    subsidiary2Year: null,
    subsidary2YearLimitedTimeOnly: null,
    // Bundle
    bundleHalfYear: null,
    bundle1Year: null,
    bundle2Year: null,
    bundle2YearLimitedTimeOnly: null,

    reinstatementFee: null,
    overseasCharges: null,
  },
  formFields: [
    // title object start
    {
      id: "category",
      lable: "",
      Field_Name: "Category",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "category",
      fieldSetting: {
        formTitle: "Category",
      },
      style: {
        containerCss: "custom-grid",
      },
    },
    {
      id: "halfYearSubscriptionFee",
      lable: "",
      Field_Name: "Subscription Fee (0.5-Year Hidden)",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "halfYearSubscriptionFee",
      fieldSetting: {
        formTitle: "Subscription Fee (0.5-Year Hidden)",
      },
      style: {
        containerCss: "custom-grid",
      },
    },
    {
      id: "firstYearSubscriptionFee",
      lable: "",
      Field_Name: "1-Year Subscription Fee",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "firstYearSubscriptionFee",
      fieldSetting: {
        formTitle: "1-Year Subscription Fee",
      },
      style: {
        containerCss: "custom-grid",
      },
    },
    {
      id: "secoundYearSubscriptionFee",
      lable: "",
      Field_Name: "2-Year Subscription Fee",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "secoundYearSubscriptionFee",
      fieldSetting: {
        formTitle: "2-Year Subscription Fee",
      },
      style: {
        containerCss: "custom-grid",
      },
    },
    {
      id: "twoYearLimitedSubscriptionFee",
      lable: "",
      Field_Name: "Subscription Fee (2-Year Limited)",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "twoYearLimitedSubscriptionFee",
      fieldSetting: {
        formTitle: "Subscription Fee (2-Year Limited)",
      },
      style: {
        containerCss: "custom-grid last-grid",
      },
    },
    // Standard object start
    {
      id: "Standard",
      lable: "",
      Field_Name: "",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "Standard",
      fieldSetting: {
        formTitle: "Standard",
      },
      style: {
        containerCss: "category-title",
      },
    },
    {
      id: "standardHalfYear",
      lable: "",
      Field_Name: "standardHalfYear",
      fieldType: FormFieldTypes.INPUT,
      dataField: "standardHalfYear",
      fieldSetting: {
        placeholder: "$ ",
        allowSpace: true,
        maskFormat: "$ ",
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "custom-grid",
      },
    },
    {
      id: "standard1Year",
      lable: "",
      Field_Name: "standard1Year",
      fieldType: FormFieldTypes.INPUT,
      dataField: "standard1Year",
      fieldSetting: {
        placeholder: "$",
        allowSpace: true,
        maskFormat: "$ ",
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "custom-grid",
      },
    },
    {
      id: "standard2Year",
      lable: "",
      Field_Name: "standard2Year",
      fieldType: FormFieldTypes.INPUT,
      dataField: "standard2Year",
      fieldSetting: {
        placeholder: "$",
        allowSpace: true,
        maskFormat: "$ ",
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "custom-grid",
      },
    },
    {
      id: "standard2YearLimitedTimeOnly",
      lable: "",
      Field_Name: "standard2YearLimitedTimeOnly",
      fieldType: FormFieldTypes.INPUT,
      dataField: "standard2YearLimitedTimeOnly",
      fieldSetting: {
        placeholder: "$",
        allowSpace: true,
        maskFormat: "$ ",
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "custom-grid last-grid",
      },
    },
    // Standard object end

    // Subsidiary object start
    {
      id: "Subsidiary",
      lable: "",
      Field_Name: "Green Mark AAP",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "Subsidiary",
      fieldSetting: {
        formTitle: "Subsidiary",
      },
      style: {
        containerCss: "category-title",
      },
    },
    {
      id: "subsidiaryHalfYear",
      lable: "",
      Field_Name: "subsidiaryHalfYear",
      fieldType: FormFieldTypes.INPUT,
      dataField: "subsidiaryHalfYear",
      fieldSetting: {
        placeholder: "$ ",
        allowSpace: true,
        maskFormat: "$ ",
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "custom-grid",
      },
    },
    {
      id: "subsidiary1Year",
      lable: "",
      Field_Name: "subsidiary1Year",
      fieldType: FormFieldTypes.INPUT,
      dataField: "subsidiary1Year",
      fieldSetting: {
        placeholder: "$",
        allowSpace: true,
        maskFormat: "$ ",
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "custom-grid",
      },
    },
    {
      id: "subsidiary2Year",
      lable: "",
      Field_Name: "subsidiary2Year",
      fieldType: FormFieldTypes.INPUT,
      dataField: "subsidiary2Year",
      fieldSetting: {
        placeholder: "$",
        allowSpace: true,
        maskFormat: "$ ",
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "custom-grid",
      },
    },
    {
      id: "subsidary2YearLimitedTimeOnly",
      lable: "",
      Field_Name: "subsidary2YearLimitedTimeOnly",
      fieldType: FormFieldTypes.INPUT,
      dataField: "subsidary2YearLimitedTimeOnly",
      fieldSetting: {
        placeholder: "$",
        allowSpace: true,
        maskFormat: "$ ",
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "custom-grid last-grid",
      },
    },
    // Subsidiary object end
    //Bundle object start
    {
      id: "sgbcBundle",
      lable: "",
      Field_Name: "SGBS Bundle",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "sgbcBundle",
      fieldSetting: {
        formTitle: "SGBS Bundle",
      },
      style: {
        containerCss: "category-title",
      },
    },
    {
      id: "sgbcBundleHalfYear",
      lable: "",
      Field_Name: "sgbcBundleHalfYear",
      fieldType: FormFieldTypes.INPUT,
      dataField: "sgbcBundleHalfYear",
      fieldSetting: {
        placeholder: "$",
        allowSpace: true,
        maskFormat: "$ ",
        isDisable:true
      },
    //  validation: [{ type: "require" }],
      style: {
        containerCss: "custom-grid",
      },
    },
    {
      id: "sgbcBundle1Year",
      lable: "",
      Field_Name: "sgbcBundle1Year",
      fieldType: FormFieldTypes.INPUT,
      dataField: "sgbcBundle1Year",
      fieldSetting: {
        placeholder: "$ ",
        allowSpace: true,
        maskFormat: "$ ",
        isDisable:true
      },
    //  validation: [{ type: "require" }],
      style: {
        containerCss: "custom-grid",
      },
    },
    {
      id: "sgbcBundle2Year",
      lable: "",
      Field_Name: "sgbcBundle2Year",
      fieldType: FormFieldTypes.INPUT,
      dataField: "sgbcBundle2Year",
      fieldSetting: {
        placeholder: "$ ",
        allowSpace: true,
        maskFormat: "$ ",
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "custom-grid",
      },
    },
    {
      id: "sgbcBundle2YearLimitedTimeOnly",
      lable: "",
      Field_Name: "sgbcBundle2YearLimitedTimeOnly",
      fieldType: FormFieldTypes.INPUT,
      dataField: "sgbcBundle2YearLimitedTimeOnly",
      fieldSetting: {
        placeholder: "$",
        allowSpace: true,
        maskFormat: "$ ",
        options: [],
        isDisable:true
      },
     // validation: [{ type: "require" }],
      style: {
        containerCss: "custom-grid last-grid",
      },
    },
    // Bundle object end
    {
      id: "",
      lable: "",
      Field_Name: "",
      fieldType: FormFieldTypes.SEPARATOR,
      dataField: "",
      fieldSetting: {
        placeholder: "",
      },
      style: {
        containerCss: "separator-line col-md-12",
      },
    },
    {
      id: "",
      lable: "",
      Field_Name: "",
      fieldType: FormFieldTypes.SEPARATOR,
      dataField: "",
      fieldSetting: {
        placeholder: "",
      },
      style: {
        containerCss: "separator-line col-md-12",
      },
    },
    {
      id: "",
      lable: "",
      Field_Name: "",
      fieldType: FormFieldTypes.SEPARATOR,
      dataField: "",
      fieldSetting: {
        placeholder: "",
      },
      style: {
        containerCss: "separator-line col-md-12",
      },
    },
    {
      id: "",
      lable: "",
      Field_Name: "",
      fieldType: FormFieldTypes.SEPARATOR,
      dataField: "",
      fieldSetting: {
        placeholder: "",
      },
      style: {
        containerCss: "separator-line col-md-12",
      },
    },
    {
      id: "",
      lable: "",
      Field_Name: "",
      fieldType: FormFieldTypes.SEPARATOR,
      dataField: "",
      fieldSetting: {
        placeholder: "",
      },
      style: {
        containerCss: "separator-line col-md-12",
      },
    },
    {
      id: "",
      lable: "",
      Field_Name: "",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "",
      fieldSetting: {
        placeholder: "",
      },
      style: {
        containerCss: "category-title col-md-12",
      },
    },
    {
      id: "reinstatementFee",
      lable: "Reinstatement Fee",
      Field_Name: "reinstatementFee",
      fieldType: FormFieldTypes.INPUT,
      dataField: "reinstatementFee",
      fieldSetting: {
        placeholder: "$",
        allowSpace: true,
        maskFormat: "$ ",
      },

      style: {
        containerCss: "custom-grid",
      },
    },

    {
      id: "overseasCharges",
      lable: "Overseas Charge Fee",
      Field_Name: "overseasCharges",
      fieldType: FormFieldTypes.INPUT,
      dataField: "overseasCharges",
      fieldSetting: {
        placeholder: "$",
        allowSpace: true,
        maskFormat: "$ ",
      },

      style: {
        containerCss: "custom-grid last-grid",
      },
    },
  ],

  formSetting: {
    isViewOnly: false,
  },
};
